import $ from "jquery";
import "waypoints/lib/jquery.waypoints";
let Backbone;

let Handlebars;
let Metrics;

Backbone = require("backbone");

Handlebars = require("handlebars");
require("./handlebar_helpers");

Metrics = require("../helpers/metrics").default;

let ResultsView;
let append_container;
let icon;
let iconlist;
let pageCount;
let pageLimit;
let parent;
let template;
let url;

append_container = void 0;

parent = void 0;

iconlist = void 0;

icon = void 0;

pageCount = void 0;

pageLimit = void 0;

ResultsView = void 0;

url = void 0;

template = $("#handlebar-template");

let noun = window.noun;
class Backbone_Icon_List {
    constructor(
        append_container,
        ajaxURL,
        page,
        handlebar_template,
        limit,
        wp_el
    ) {
        let Icon;
        let IconList;
        let me;

        this.raw_html = "false";

        this.$wp_el = void 0;

        this.on_finish = void 0;

        this.status = void 0;

        me = this;
        me.$wp_el = wp_el;
        append_container = $(append_container);
        parent = append_container.parent();
        url = ajaxURL;
        pageCount = page;
        if (limit !== void 0) {
            pageLimit = limit;
        } else {
            pageLimit = 50;
        }
        if (handlebar_template !== void 0) {
            template = handlebar_template;
        }
        Icon = Backbone.Model.extend({
            defaults: {
                loading:
                    '<div class="loading clearfix"><div class="dot dot1"></div><div class="dot dot2"></div><div class="dot dot3"></div><div class="dot dot4"></div></div>',
                error: "/static/img/fallback-icon.svg",
                id: 0,
                term_slug: "None",
                preview_url: "None"
            },
            idAttribute: "cid"
        });
        IconList = Backbone.Collection.extend({
            model: Icon,
            url() {
                return ajaxURL;
            }
        });
        iconlist = new IconList();
        icon = new Icon();
        ResultsView = Backbone.View.extend({
            el: append_container,
            initialize() {
                this.render();
            },
            render() {
                let HTML;
                let compiled_template;
                let i;
                let icon_array;
                let len;
                let ref;
                let wrapper;
                if (template === "html") {
                    HTML = iconlist.models[0].attributes.html;
                } else {
                    compiled_template = Handlebars.compile(template.html());
                    icon_array = [];
                    ref = iconlist.models;
                    for (i = 0, len = ref.length; i < len; i++) {
                        icon = ref[i];
                        icon_array.push(icon.attributes);
                    }
                    wrapper = {
                        objects: icon_array
                    };
                    HTML = compiled_template(wrapper);
                }
                $(this.el).append(HTML);
                if (me.on_finish !== void 0) {
                    me.on_finish();
                }
            }
        });
        parent.append(icon.attributes.loading);
        this.scroll();
    }

    scroll() {
        let $footer;
        let $wp_el;
        let has_failed;
        let me;
        me = this;
        has_failed = false;
        $footer = $("#site-footer");
        if (this.$wp_el === void 0) {
            $wp_el = $("#logout-form");
        } else {
            $wp_el = this.$wp_el;
        }
        if (template === "html") {
            icon = Backbone.Model.extend({
                defaults: {
                    html: "",
                    is_owner: ""
                }
            });
            iconlist.model = icon;
            me.raw_html = "true";
        }
        return $wp_el.waypoint({
            handler: () => {
                if (has_failed === false) {
                    $(".loading").removeClass("hidden");
                    if (me.status !== "firing") {
                        me.status = "firing";
                        return iconlist.fetch({
                            data: {
                                page: pageCount,
                                limit: pageLimit,
                                raw_html: me.raw_html
                            },
                            success(method, model, options) {
                                let resultsView;
                                if (model.length === 0) {
                                    has_failed = true;
                                }
                                me.status = "finished";
                                pageCount = pageCount + 1;
                                if (document.location.pathname === "/search/") {
                                    new noun.Metrics().page_depth(pageCount);
                                }
                                resultsView = new ResultsView();
                                $(".loading").addClass("hidden");
                                // eslint-disable-next-line no-undef
                                return Waypoint.refreshAll();
                            },
                            error(jqXHR, textStatus, errorThrown) {
                                $(".loading").addClass("hidden");
                                return (has_failed = true);
                            }
                        });
                    }
                }
            },
            offset: "110%"
        });
    }
}

export default Backbone_Icon_List;
